import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'gtd-form-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-message.component.html',
})
export class FormMessageComponent implements ControlValueAccessor {
  @Input() data = '';
  @Input() url = '';
  @HostBinding('class') className = 'p500-ui-modal p500-ui-modal--primary c-modal c-modal--info';
  public onChange: (value: string[]) => void;
  public onTouch: () => void;

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(): void {}
}
